const CAMPAIGN_POINTS_TABLE = {
  path: '/campaign/:campaignId/points',
  component: () =>
    import('@/pages/CampaignPoints/CampaignPointsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'campaign-points.index',
      component: () => import('@/pages/CampaignPoints/CampaignPointsPage.vue'),
    },
    {
      path: 'create',
      name: 'campaign-points.create',
      component: () =>
        import('@/pages/CampaignPoints/CampaignPointsFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'campaign-points.edit',
      component: () =>
        import('@/pages/CampaignPoints/CampaignPointsFormPage.vue'),
    },
  ],
};

export default CAMPAIGN_POINTS_TABLE;
